<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-jumbotron v-if="errorMessage.length > 0">
          <b-row align-h="center">
            <b-alert show variant="danger">{{ errorMessage }}<b>!</b></b-alert>
          </b-row>
        </b-jumbotron>

        <b-jumbotron v-else class="quiz-container">
          <template v-if="!isQuizActive">
            <b-row align-h="center" class="mb-3">
              <h5>Training Quiz</h5>
            </b-row>
            <control-button>
              <b-row align-h="center">
                <b-button
                  variant="primary"
                  @click="() => (isQuizActive = !isQuizActive)"
                  >Start</b-button
                >
              </b-row>
            </control-button>
          </template>

          <template v-else>
            <b-card-header
              header-bg-variant="light"
              align="center"
              header-class="question-number"
              >Question {{ question.currentIndex + 1 }} /
              {{ totalQuestions }}</b-card-header
            >
            <div>{{ question.description }}</div>

            <b-container
              ref="buttons"
              fluid
              class="p-0 mt-4 mb-4 container-answers"
            >
              <b-button
                v-for="ans in question.possibleAnswers"
                :key="ans.id"
                :data-id="ans.id"
                variant="info"
                @click="toggleAnswers(ans.id)"
                >{{ ans.answer }}</b-button
              >
            </b-container>

            <control-button :extra-class="'right-corner'">
              <b-button
                :disabled="isNextBtnDisabled"
                variant="dark"
                @click="setNextQuestion"
                >{{
                  question.currentIndex !== totalQuestions - 1
                    ? 'Next'
                    : 'Finish'
                }}</b-button
              >
            </control-button>
          </template>
        </b-jumbotron>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { requester } from '../../helpers/requester';
import ControlButton from './ControlButton.vue';

export default {
  name: 'App',
  components: {
    ControlButton
  },
  data() {
    return {
      isQuizActive: false,
      errorMessage: '',

      quizQuestions: null,
      totalQuestions: 0,
      currentAnswerId: null,
      isNextBtnDisabled: true,
      buttons: null,

      question: {
        id: null,
        currentIndex: 0,
        description: '',
        possibleAnswers: []
      }
    };
  },
  computed: {},
  beforeMount() {
    this.fetchQuizData();
  },
  methods: {
    async fetchQuizData() {
      const req = await requester();

      req
        .get('/training_quiz')
        .then(res => {
          this.initQuizQuestionDetails(res.data.quiz_questions);
        })
        .catch(() => {
          this.errorMessage = `Something went wrong with quiz questions`;
        });
    },
    initQuizQuestionDetails(questions) {
      this.quizQuestions = questions;
      this.totalQuestions = this.quizQuestions.length;
      this.displayQuestion();
    },
    displayQuestion() {
      const currQuestion = this.quizQuestions[this.question.currentIndex];

      if (currQuestion.answer_id) {
        if (this.isQuizFinished()) {
          this.directInterviewQuizDone();
        } else {
          this.question.currentIndex += 1;
          this.displayQuestion();
        }

        return;
      }

      this.question.id = currQuestion.id;
      this.question.description = currQuestion.question;
      this.question.possibleAnswers = currQuestion.answers;
    },
    async setNextQuestion() {
      this.isNextBtnDisabled = true;
      await this.postAnswer();

      const isFinished = this.isQuizFinished();

      if (!isFinished) {
        this.uncheckAnswers();
        this.question.currentIndex += 1;
        this.displayQuestion();
      } else {
        this.directInterviewQuizDone();
      }
    },
    uncheckAnswers() {
      this.currentAnswerId = null;
    },
    toggleAnswers(answerId) {
      if (answerId === this.currentAnswerId) return;

      const currBtn = Array.from(this.$refs.buttons.childNodes).find(
        btn => parseInt(btn.getAttribute('data-id'), 10) === answerId
      );

      if (this.currentAnswerId) {
        const prevBtn = Array.from(this.$refs.buttons.childNodes).find(
          btn =>
            parseInt(btn.getAttribute('data-id'), 10) === this.currentAnswerId
        );
        prevBtn.classList.toggle('active');
      }

      this.isNextBtnDisabled = false;
      this.currentAnswerId = answerId;
      currBtn.classList.toggle('active');
    },
    async postAnswer() {
      const req = await requester();
      req
        .post('/training_quiz_answer', {
          question_id: this.question.id,
          answer_id: this.currentAnswerId
        })
        .catch(e => console.log(e.message));
    },
    isQuizFinished() {
      return this.question.currentIndex >= this.totalQuestions - 1;
    },
    directInterviewQuizDone() {
      this.$emit('quizFinished', true);
    }
  }
};
</script>

<style lang="scss" scoped>
$white: #fff;
$orange: #f68b24;
$orange8: rgba(246, 139, 36, 0.8);
$orange5: rgba(246, 139, 36, 0.5);

.quiz-container {
  box-shadow: 0px 5px 20px 2px #8e6c41;
}
.question-number {
  font-weight: 700;
  border-radius: 2px;
  margin-bottom: 1rem;
}
.container-answers {
  display: grid;
  gap: 10px;
}
@media screen and (min-width: 386px) {
  .container-answers {
    grid-template-columns: repeat(2, calc(50% - 5px));
  }
}

.btn-info {
  border-color: $orange;
  background: $white;
  color: $orange;

  &:hover {
    border-color: $orange5;
    background: $orange5;
  }
}
.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  border-color: $white;
  background: $orange8;
  color: $white;
}

.btn-primary,
.btn-primary:disabled {
  border-color: $orange8;
  background: $orange8;
  color: $white;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.btn-primary:hover:enabled,
.btn-primary:focus:enabled,
.btn-primary:active:enabled {
  border-color: $orange;
  background: $orange;
  color: $white;
}
</style>
